module.exports = __webpack_public_path__ + "img/logo_cs.960079f1.svg";